import { render, staticRenderFns } from "./directoryConfiguration.vue?vue&type=template&id=0ec64349"
import script from "./directoryConfiguration.vue?vue&type=script&lang=js"
export * from "./directoryConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports